import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '홈', path: '/' },
  { label: '서비스', path: '/services' },
  { label: '포트폴리오', path: '/portfolio' },
  { label: '정보', path: '/info' },
  { label: '견적', path: '/estimate' },
  { label: '상담', path: '/consultation' },
  { label: '연락처', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#f4f2f0]/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer ml-10">
          <img
            src="https://storage.readdy-site.link/project_files/0477f867-7633-4e4c-8292-18c2b50a08d2/71c3eeb4-b7dc-4194-9d28-765078511092_2.jpg"
            alt="feel green 로고"
            className="h-12 w-12 object-cover rounded-lg bg-green-600"
          />
          <span
            className={`text-base font-bold tracking-widest transition-colors duration-300 ${scrolled ? 'text-[#3a3228]' : 'text-white'}`}
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            feel green
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-[#c9a84c]'
                  : scrolled ? 'text-[#3a3228]/80 hover:text-[#c9a84c]' : 'text-white/80 hover:text-[#c9a84c]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <Link
          to="/consultation"
          className="hidden md:flex items-center gap-2 bg-[#c9a84c] text-[#0d0d0d] text-sm font-bold px-6 py-3 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#b8973b] transition-colors duration-200"
        >
          무료 상담 신청
        </Link>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-[#3a3228]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴 열기"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#f4f2f0]/98 backdrop-blur-md border-t border-[#d8d4ce]/30">
          <nav className="flex flex-col px-6 py-4 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`py-3 text-sm font-medium tracking-wide border-b border-[#d8d4ce]/30 cursor-pointer flex items-center gap-2 ${
                  location.pathname === link.path ? 'text-[#c9a84c]' : 'text-[#3a3228]/80'
                }`}
              >
                {link.path === '/' && <i className="ri-home-4-line text-base" />}
                {link.label}
              </Link>
            ))}
            <Link
              to="/consultation"
              className="mt-4 bg-[#c9a84c] text-[#0d0d0d] text-sm font-bold px-6 py-3 rounded-full text-center whitespace-nowrap cursor-pointer"
            >
              무료 상담 신청
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
